import { Store, Module, ActionContext } from 'vuex';
import ListModule from '../list-module';
import ListState from '../list-state';
import ProductCategory from '@/store/entities/baseInfo/ProductCategory';
import Ajax from '@/lib/ajaxBaseInfo';
import PageResult from '@/store/entities/page-result';
import VendorProductCategory from '@/store/entities/baseInfo/VendorProductCategory';
import Util from '@/lib/util';

interface ProductCategoryState extends ListState<ProductCategory> {
    editProductCategory: ProductCategory;
    footerLinkList: Array<ProductCategory>;
    vendorProductCategoryList: Array<VendorProductCategory>;
}

class ProductCategoryModule extends ListModule<ProductCategoryState, any, ProductCategory> {
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<ProductCategory>(),
        loading: false,
        editProductCategory: new ProductCategory(),
        footerLinkList: new Array<ProductCategory>(),
        vendorProductCategoryList: new Array<VendorProductCategory>()
    }
    actions = {
        async getList(context: ActionContext<ProductCategoryState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/ProductCategory/GetList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<ProductCategory>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async getNavigationList(context: ActionContext<ProductCategoryState, any>, payload: any) {
            let navigationDataTimeout = localStorage.getItem('getNavigationListCacheTimeout');
            if (!navigationDataTimeout || Number.parseInt(navigationDataTimeout) < +new Date()) {
                context.state.loading = true;
                const reponse = await Ajax.get('/ProductCategory/getNavigationList', { params: payload.data });
                context.state.loading = false;
                const page = reponse.data.result as PageResult<ProductCategory>;
                context.state.totalCount = page.totalCount;
                context.state.list = page.items;
                const footerLinks = new Array<ProductCategory>();

                (page.items || []).forEach((x) => {
                    if (x.isFooterLink) {
                        footerLinks.push(x);
                    }
                    if (x.children) {
                        x.children.forEach(y => {
                            if (y.isFooterLink) {
                                footerLinks.push(y);
                            }
                        });
                    }
                });
                context.state.footerLinkList = footerLinks;

                localStorage.setItem('totalCount', context.state.totalCount.toString());
                localStorage.setItem('footerLinkList', JSON.stringify(context.state.footerLinkList));
                localStorage.setItem('categories', JSON.stringify(context.state.list));
                localStorage.setItem('getNavigationListCacheTimeout', (+new Date() + 60 * 1000).toString());
            }

            context.state.totalCount = Number.parseInt(localStorage.getItem('totalCount'));
            context.state.footerLinkList = JSON.parse(localStorage.getItem('footerLinkList'));
            context.state.list = JSON.parse(localStorage.getItem('categories'));
        },
        async getNavigationListByVendor(context: ActionContext<ProductCategoryState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/ProductCategory/GetNavigationListByVendor?vendorNo=' + payload.data);
            context.state.loading = false;
            let list = reponse.data.result as Array<VendorProductCategory>;
            context.state.vendorProductCategoryList = list;
        },
        async create(context: ActionContext<ProductCategoryState, any>, payload: any) {
            await Ajax.post('/ProductCategory/Create', payload.data);
        },
        async update(context: ActionContext<ProductCategoryState, any>, payload: any) {
            await Ajax.put('/ProductCategory/Update', payload.data);
        },
        async delete(context: ActionContext<ProductCategoryState, any>, payload: any) {
            await Ajax.delete('/ProductCategory/Delete?Id=' + payload.data.id);
        },
        async get(context: ActionContext<ProductCategoryState, any>, payload: any) {
            let reponse = await Ajax.get('/ProductCategory/Get?Id=' + payload.data.id);
            context.state.editProductCategory = reponse.data.result as ProductCategory; // set value for editing.
            return reponse.data.result as ProductCategory;
        },
    };
    mutations = {
        setCurrentPage(state: ProductCategoryState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: ProductCategoryState, pagesize: number) {
            state.pageSize = pagesize;
        }
    }
}
const productCategoryModule = new ProductCategoryModule();
export default productCategoryModule;